import PersonaType from 'owa-service/lib/contract/PersonaType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import searchCache from 'owa-recipient-cache/lib/selectors/searchCache';
import { action } from 'satcheljs/lib/legacy';

const NUM_SUGGESTED_CONTACTS = 5;

export default action('getAndPopulateSuggestedContacts')(function getAndPopulateSuggestedContacts(
    resultsToPopulate: PersonaType[],
    wellContents?: { EmailAddress: EmailAddressWrapper }[]
) {
    let rcTopFive = searchCache('' /* searchQuery */, NUM_SUGGESTED_CONTACTS, wellContents);
    let personaTypeSet = rcTopFive.map(result => {
        return {
            EmailAddress: result.EmailAddress,
            PersonaId: result.PersonaId,
            ADObjectId: result.ADObjectId,
        };
    });
    resultsToPopulate.splice(0, resultsToPopulate.length, ...personaTypeSet);
});
